import type { DismissablePromptType } from '@ms/yammer-graphql';
import {
  useLoadDismissablePromptsByType,
  useShouldStartDismissablePrompt,
} from '@ms/yammer-hooks/dist/dismissablePromptsByType';
import type { ReactNode } from 'react';
import React, { Suspense } from 'react';

import LoadableMaintenanceOutageBanner from './LoadableMaintenanceOutageBanner';
import LoadableOutageBanner from './LoadableOutageBanner';
import LoadableScheduledMaintenanceOutageBanner from './LoadableScheduledMaintenanceOutageBanner';
import type { BannerProps } from './types';

const outagePromptTypes: DismissablePromptType[] = [
  'LIVE_SITE_ISSUE',
  'MAINTENANCE_OUTAGE',
  'MAINTENANCE_OUTAGE_SCHEDULED',
];
type UseOutageBanner = (args?: BannerProps) => ReactNode;
export const useOutageBanner: UseOutageBanner = ({ entryPoint } = {}) => {
  useLoadDismissablePromptsByType(outagePromptTypes);

  const shouldShowLiveSiteBanner = useShouldStartDismissablePrompt('LIVE_SITE_ISSUE');
  const shouldShowMaintenanceBanner = useShouldStartDismissablePrompt('MAINTENANCE_OUTAGE');
  const shouldShowScheduledMaintenanceBanner = useShouldStartDismissablePrompt('MAINTENANCE_OUTAGE_SCHEDULED');

  if (shouldShowLiveSiteBanner) {
    return (
      <Suspense fallback={null}>
        <LoadableOutageBanner entryPoint={entryPoint} />
      </Suspense>
    );
  }

  if (shouldShowMaintenanceBanner) {
    return (
      <Suspense fallback={null}>
        <LoadableMaintenanceOutageBanner entryPoint={entryPoint} />
      </Suspense>
    );
  }

  if (shouldShowScheduledMaintenanceBanner) {
    return (
      <Suspense fallback={null}>
        <LoadableScheduledMaintenanceOutageBanner entryPoint={entryPoint} />
      </Suspense>
    );
  }

  return null;
};
